module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.itemDetalhesModal),
      callback: function($$v) {
        _vm.itemDetalhesModal = $$v
      },
      expression: "itemDetalhesModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-4  mt-2 mb-2 headline"
  }, [_vm._v(_vm._s(_vm.item.id === '' ? 'Novo item' : _vm.item.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.itemDetalhesModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-form', {
    ref: "itemForm",
    attrs: {
      "name": "form-cadastro"
    }
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "pl-5 pr-5",
    staticStyle: {
      "background-color": "#f5f5f5"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes-categoria",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md2": ""
    }
  }, [_vm._v("\n              Categorias\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.categories,
      "rules": _vm.rules.categories,
      "value": _vm.item.categories,
      "item-text": "name",
      "item-value": "id",
      "label": "",
      "single-line": "",
      "bottom": "",
      "required": ""
    },
    on: {
      "input": _vm.updateCategories
    },
    model: {
      value: (_vm.setLocale),
      callback: function($$v) {
        _vm.setLocale = $$v
      },
      expression: "setLocale"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "pb-5": ""
    }
  }, [_vm._v("\n              Detalhes\n            ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "logo",
    attrs: {
      "xs12": "",
      "md12": "",
      "pb-3": ""
    }
  }, [_c('p', [_vm._v("Imagem do Item")]), _vm._v(" "), (_vm.isImg) ? _c('div', {
    staticClass: "item-image-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.images[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                    "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.removeImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                  ")], 1)])]) : [(_vm.shelfedImage !== '') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.cropperOn) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "mr-3": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.shelfedImage,
      "alt": "",
      "id": "imgToCrop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "crop-action",
    on: {
      "click": _vm.crop
    }
  }, [_c('v-icon', [_vm._v("done")]), _vm._v(" Recortar\n                    ")], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "cropped-box"
  }, [_c('div', {
    staticClass: "crop-preview"
  }, [_c('img', {
    style: (_vm.cropPreviewStyle),
    attrs: {
      "src": _vm.shelfedImage,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.cropperOn) ? _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                          "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.unshelfImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                        ")], 1)]) : _vm._e()])])], 1) : [_c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-image-box"
  }, [_c('div', {
    staticClass: "pa-2 noselect foto"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v("\n                      imagem do item\n                    ")], 1)])]]], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "label": "Nome do item",
      "rules": _vm.rules.name,
      "value": typeof _vm.item.name !== 'undefined' ? _vm.item.name : '',
      "required": ""
    },
    on: {
      "input": _vm.updateName
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Insira o nome do item.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "descricao",
      "label": "Descrição",
      "rules": _vm.rules.description,
      "value": typeof _vm.item.description !== 'undefined' ? _vm.item.description : '',
      "multi-line": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": _vm.updateDescription
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Descreva detalhadamente o item e suas características.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra Chave",
      "append-icon": _vm.dataTags !== '' ? 'send' : '',
      "append-icon-cb": _vm.addTag
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTag($event)
      }
    },
    model: {
      value: (_vm.dataTags),
      callback: function($$v) {
        _vm.dataTags = $$v
      },
      expression: "dataTags"
    }
  }), _vm._v(" "), _vm._l((_vm.item.tags), function(tag, index) {
    return _c('v-chip', {
      key: index,
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.removeTag(tag)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tag) + "\n              ")])
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Informe palavras que descrevam o item.")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Seu Código",
      "value": _vm.item.code
    },
    on: {
      "input": _vm.updateCode
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Caso seu item possua um código de controle interno, informe aqui.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Familia",
      "value": _vm.item.family
    },
    on: {
      "input": _vm.updateFamily
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Ex.: limpeza, pet, alimentação, etc.")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n                  Ativo\n                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('p', [_vm._v("Escolha 'SIM', caso queira que este item apareça no catálogo de produtos/serviços.")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.item.active
    },
    on: {
      "input": _vm.toggleActive
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sequencia",
      "value": _vm.item.seq
    },
    on: {
      "input": _vm.updateSeq
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Campo sequencia - ordenar os itens por prioridades de visualização, ou seja, os itens que devem ser visualizados primeiro..")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n                  Vigência\n                  "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Determina quando começa e quando termina a exibição do item.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pr-2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Início",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.validityStartLabel),
      callback: function($$v) {
        _vm.validityStartLabel = $$v
      },
      expression: "validityStartLabel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "value": _vm.validityStartPicker,
      "first-day-of-week": 1,
      "locale": "pt-br",
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    on: {
      "input": _vm.updateValidityStart
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Fim",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.validityEndLabel),
      callback: function($$v) {
        _vm.validityEndLabel = $$v
      },
      expression: "validityEndLabel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "value": _vm.validityEndPicker,
      "first-day-of-week": 1,
      "locale": "pt-br",
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    on: {
      "input": _vm.updateValidityEnd
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              Variações\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('p', [_vm._v("Escolha 'SIM', caso este produto/serviço tenha variações no preço.\n                "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Ex: Pequeno, Médio, Grande...")])], 1)], 1), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.variacao
    },
    on: {
      "input": _vm.togglePriceVariations
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              Preço\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "mb-3": ""
    }
  }, [(_vm.item.priceVariations) ? [_c('v-flex', {
    ref: "pricetableList",
    staticClass: "box-variacao mt-2",
    attrs: {
      "md12": ""
    }
  }, [_vm._l((_vm.item.priceTable), function(variation, index) {
    return [_c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm1": "",
        "md1": "",
        "variation-img-box": ""
      }
    }, [_c('img', {
      staticClass: "variation-img",
      attrs: {
        "src": variation.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-change-img"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.uploadImage(index, variation.image)
        }
      }
    }, [_vm._v("alterar")])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "md3": "",
        "pr-2": ""
      }
    }, [_c('div', {
      staticClass: "price-box"
    }, [_c('v-text-field', {
      attrs: {
        "value": variation.description,
        "label": "Descricão",
        "required": "",
        "rules": _vm.rules.multiDescription
      },
      on: {
        "input": function($event) {
          return _vm.updatePriceText($event, index)
        }
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm3": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "price-box"
    }, [_c('money', {
      attrs: {
        "label": 'Valor Referência'
      },
      model: {
        value: (variation.priceRef),
        callback: function($$v) {
          _vm.$set(variation, "priceRef", $$v)
        },
        expression: "variation.priceRef"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "sm1": "",
        "md1": "",
        "pt-2": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "right": ""
      }
    }, [_c('v-icon', {
      staticClass: "ml-2 link",
      attrs: {
        "slot": "activator",
        "color": "blue"
      },
      slot: "activator"
    }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Valor original sem desconto.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm3": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "price-box"
    }, [_c('money', {
      attrs: {
        "validation": true
      },
      model: {
        value: (variation.price),
        callback: function($$v) {
          _vm.$set(variation, "price", $$v)
        },
        expression: "variation.price"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "sm1": "",
        "md1": "",
        "pt-2": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "right": ""
      }
    }, [_c('v-icon', {
      staticClass: "ml-2 link",
      attrs: {
        "slot": "activator",
        "color": "blue"
      },
      slot: "activator"
    }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Valor com desconto.")])], 1), _vm._v(" "), _c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteMultiPrice(index)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)]
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addMultiPrice($event)
      }
    }
  }, [_vm._v("add")])], 1)], 2)] : [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "mt-3": ""
    }
  }, [_c('div', {
    staticClass: "price-box"
  }, [_c('money', {
    attrs: {
      "validation": true
    },
    model: {
      value: (_vm.item.price),
      callback: function($$v) {
        _vm.$set(_vm.item, "price", $$v)
      },
      expression: "item.price"
    }
  })], 1)])]], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              Formas de pagamento\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.payments,
      "value": _vm.item.payments,
      "multiple": "",
      "item-text": "description",
      "item-value": "id",
      "label": "",
      "single-line": "",
      "bottom": "",
      "required": ""
    },
    on: {
      "input": _vm.updatePayments
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              O tipo de serviço que sua empresa presta requer definição de horários?\n              "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Coloque sim, caso o tipo de serviço prestado pela sua empresa tenha horários de atendimentos diferenciados durante a semana.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('SelectionBtn', {
    staticClass: "font-14",
    attrs: {
      "value": _vm.needSchedule
    },
    on: {
      "input": _vm.toggleNeedSchedule
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": ""
    }
  }, [(_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Sábado")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.saturdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSaturdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.saturdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSaturdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.saturdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateSaturdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.saturdayCapacity
    },
    on: {
      "change": _vm.updateSaturdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Domingo")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.sundayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSundayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.sundayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSundayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.sundayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateSundayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.sundayCapacity
    },
    on: {
      "change": _vm.updateSundayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.customTime) ? [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Segunda a Sexta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.weekDayStart,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWeekdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.weekDayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWeekdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.weekDayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWeekdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.weekDayCapacity
    },
    on: {
      "change": _vm.updateWeekdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)] : [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Segunda")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.mondayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateMondayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.mondayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateMondayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.mondayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateMondayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.mondayCapacity
    },
    on: {
      "change": _vm.updateMondayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)]], 2) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Terça")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.tuesdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateTuesdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.tuesdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateTuesdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.tuesdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateTuesdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.tuesdayCapacity
    },
    on: {
      "change": _vm.updateTuesdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Quarta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.wednesdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWednesdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.wednesdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWednesdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.wednesdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWednesdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.wednesdayCapacity
    },
    on: {
      "change": _vm.updateWednesdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Quinta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.thursdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateThursdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.thursdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateThursdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.thursdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateThursdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.thursdayCapacity
    },
    on: {
      "change": _vm.updateThursdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Sexta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.fridayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateFridayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.fridayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateFridayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.fridayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateFridayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.fridayCapacity
    },
    on: {
      "change": _vm.updateFridayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md6": ""
    }
  }, [_c('p', {}, [_vm._v("Horários distintos durante a semana")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.customTime
    },
    on: {
      "input": _vm.toggleCustomTime
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Se o tipo de serviço prestado pela sua empresa tem horários de atendimentos diferenciados durante a semana, preencha a próxima tela.")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-4",
    attrs: {
      "flat": "",
      "outline": "",
      "round": "",
      "color": "green",
      "disabled": _vm.loadingItemAction
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateItem()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("done_all")]), _vm._v("Gravar")], 1)], 1)], 1), _vm._v(" "), (_vm.loadingItemAction) ? _c('v-progress-linear', {
    staticClass: "loading-modal",
    attrs: {
      "color": "error",
      "indeterminate": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', [_c('ImageUpload')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a97b719","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/itens/itemDetalhes.vue
// module id = 734
// module chunks = 2